import { useField } from "formik";
import { EfsMelcoEfsModelsSchemaListItem } from "melco-shared-logic";
import { SelectDataSource } from "./SelectDataSource";

type ScopedFilenameRuleProps = {
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[];
  scopeType: "Scoped" | "ScopedPrefix" | "ScopedSuffix";
};

export const ScopedFilenameRule: React.FC<ScopedFilenameRuleProps> = ({
  dataAssignments,
  scopeType,
}) => {
  const [{ value: type }] = useField("type");

  if (type !== scopeType) {
    return null;
  }

  return (
    <SelectDataSource
      dataAssignments={dataAssignments}
      name="format_detail_id"
    />
  );
};
